import moment from "moment"
import { createContext, useContext, useMemo, useRef, useState } from "react"
import { useIntl } from "react-intl"
import { toast } from "react-toastify"
import Swal from 'sweetalert2'
import IKhcHub from "utils/khc-hub"
import tr from "../components/translate/tr.json"
import PropTypes from "prop-types"


const toastOpts = {
    position: "bottom-center",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    draggable: false,
    progress: undefined,
    theme: "colored"
}

export const AppContext = createContext()

export function AppContextProvider({children}) {

    const intl = useIntl()
    const khcHubRef = useRef(null)
    const [redirect, setRedirect] = useState(null)

    const contextValue = useMemo(() => ({
        translate: (e, values = {}) => {
            return intl.formatMessage({id: e, defaultMessage: e}, values)
        },
        translateForAnalytics: (e) => {
            return tr[e] ? tr[e] : e;
        },
        dateFormat: (date, format = "DD.MM.YYYY") => {
            return moment(date).format(format)
        },
        toastError: (e) => {
            toast.error(e, toastOpts)
        },
        toastWarning: (e) => {
            toast.warning(e, toastOpts)
        },
        toastSuccess: (e) => {
            toast.success(e, toastOpts)
        },
        showDialog: (
            title, 
            text, 
            icon, 
            showCancelButton, 
            confirmButtonText, 
            cancelButtonText, 
            onConfirm = () => {}, 
            onCancel = () => {}, 
            html,
            cancelButtonCss = "btn btn-danger", 
            showDenyButton = false, 
            denyButtonText = "Deny",
            onDeny = () => {}
        ) => {
            Swal.fire({
                title: title,
                text: text,
                icon: icon,
                showDenyButton: showDenyButton,
                showCancelButton: showCancelButton,
                confirmButtonText: confirmButtonText,
                cancelButtonText: cancelButtonText,
                html: html,
                denyButtonText: denyButtonText,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: cancelButtonCss,
                    denyButton: 'btn btn-success'
                },
                buttonsStyling: false
            }).then((result) => {
                if (result.isConfirmed) {
                    onConfirm()
                } else if (result.isDenied) {
                    onDeny()
                } else {
                    onCancel()
                }
            })
        },
        initKhcSocket: () => {
            khcHubRef.current = new IKhcHub(intl);
            khcHubRef.current.Connect()
        },
        disconnectKhcSocket: () => {
            if (khcHubRef.current) {
                khcHubRef.current.Disconnect()
            }
        },
        baseTimezone: "Europe/Istanbul",
        userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userUtcGmt : moment().format('Z'),
        redirect,
        setRedirect: (data) => {
            setRedirect(data)
        }
    }), [intl, redirect])

    return (
        <AppContext.Provider 
        value={contextValue}
        >
            {children}
        </AppContext.Provider>
    )
}

export const useAppContext = () => {
    return useContext(AppContext);
}

AppContextProvider.propTypes = {
    children: PropTypes.node.isRequired
}
